<ng-container *ngIf="productSelection">
  <div
    id="shortlist-option-{{ productSelection.id }}"
    class="option"
    [ngClass]="{
      'option--recommended': productSelection | isRecommendedProductSelection,
      'option--preferred': productSelection | isPreferredProductSelection
    }">
    <div class="row align-items-center align-items-md-start">
      <div class="col col-md-3 col-lg-3">
        <div class="row align-items-center">
          <div class="col">
            <!-- logo / provider -->
            <div class="text-md-center">
              <app-provider-image
                [providerName]="getProviderName(productSelection)">
              </app-provider-image>
            </div>
          </div>
          <div class="col-auto col-md-12 mt-md-2 mt-lg-4 text-md-center">
            <!-- tag / preference -->
            <ng-container *ngIf="productSelection | isPreferredProductSelection">
              <div class="d-md-none">
                <lds-tag label="CP" appearance="success"></lds-tag>
              </div>
              <div class="d-none d-md-block">
                <lds-tag
                  label="Customer Preference"
                  appearance="success"></lds-tag>
              </div>
            </ng-container>

            <!-- tag / recommended -->
            <ng-container
              *ngIf="productSelection | isRecommendedProductSelection">
              <div class="d-md-none">
                <lds-tag label="AR" appearance="info"></lds-tag>
              </div>
              <div class="d-none d-md-block">
                <lds-tag
                  label="{{
                    adviserLabelCase.TitleCase | adviserLabel
                  }} Recommended"
                  appearance="info"></lds-tag>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col order-md-last pl-0">
        <!-- layout / package -->
        <ng-container
          *ngIf="isPackage(productSelection); else tplOptionProduct">
          <ng-container *ngIf="productSelection.packageProduct != null">
            <app-product-selection-package
              [package]="
                productSelection.packageProduct
              "></app-product-selection-package>
          </ng-container>
        </ng-container>

        <!-- layout / product -->
        <ng-template #tplOptionProduct>
          <ng-container *ngIf="productSelection.singleProduct != null">
            <app-product-selection-product
              [product]="
                productSelection.singleProduct
              "></app-product-selection-product>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</ng-container>
